module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 1
// module chunks = 0 1